import React, {Component} from "react";
import {toast} from 'react-toastify';
import {Input} from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import {getUser} from "../../utils/TokenManager";
import loadingGIF from "../../public/assets/images/loading.gif";
import ErrorMsg from "../common/ErrorMsg";
import StaffCalendar from "./StaffCalendar";
import ConfirmModal from "../common/ConfirmModal";
import { 
    WAITING_FOR_APPROVAL, CANCELED, PTO_REQUEST_STATUS, APPROVED, DENIED, 
} from "./Constants";
import TimeField from "../common/Time";

// import SickLeaveRequest from "../../actions/SickLeaveAction"

import SickLeaveService from "../../services/SickLeaveServices";


const EMPTY_REQUEST = {
    id: null,
    pto_type: 0,
    start_date: null,
    end_date: null,
    description: '',
    comment: '',
    status: WAITING_FOR_APPROVAL,
    is_full_first_day: true, 
    is_full_last_day: true,
    start_time: '09:00', 
    end_time: '17:00',
    is_paid: true,
    isPreviousTimeForTheSameDay: false,
}


export default class PTORequest extends Component {

    state = {
        requestObj: {...EMPTY_REQUEST},
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        isLoading: false,
        error: {},
        confirmationModalData: {},
        startAllDay: true,
        endAllDay: true,
        sick_leave_request:"time-off",
        is_sick_leave_allowed_for_user:false
    }
    Radiochangehandler = e => {
        const { name, value } = e.target;

        this.setState({
            sick_leave_request: value
        });
      };

    componentDidMount = () => {
        if (this.props.agencyLocation) {
            this.getHolidayList();
            this.getPTOType();
            this.getTimeOffList();
            this.getSickLeaveSetting();
        }

        const {selectedPTORequest} = this.props;
        if (!selectedPTORequest.clear) {
            this.showTimeOffRequest(
                selectedPTORequest.requestObj, selectedPTORequest.clear
            );
        }
        const {settings, staffPTOInfo} = this.props.pto;
        let availablePTO = 1000;
        
        if (staffPTOInfo.total_pto_accrued !== undefined) {
            availablePTO = staffPTOInfo.total_pto_accrued - (
                staffPTOInfo.used_pto + staffPTOInfo.scheduled_pto
            )
        }

        const {requestObj} = this.state;
        
        
        let isPaid = availablePTO <= 0 ? 
            false : requestObj.is_paid || settings.is_unlimited_pto;
       
        // add condition here = ....
        let id = null;
        let time_off_name = null;
        let pto_type = 0

        let start_date =  null;
        let end_date =  null;
        let description = '';
        let comment= '';
        let status = WAITING_FOR_APPROVAL;
        let is_full_first_day =  true;
        let is_full_last_day = true;
        let start_time= '09:00'; 
        let end_time= '17:00';
        
        if (!selectedPTORequest.clear) {
            isPaid = selectedPTORequest.requestObj.is_paid;
            id = selectedPTORequest.requestObj.id;
            time_off_name = selectedPTORequest.requestObj.time_off_name;
            if(time_off_name){
                this.state.sick_leave_request="time-off"
            }else{
                this.state.sick_leave_request="sick-leave"
            }
            
            pto_type = selectedPTORequest.requestObj.pto_type;

            status = selectedPTORequest.requestObj.status;
            is_full_first_day = selectedPTORequest.requestObj.is_full_first_day;
            is_full_last_day  = selectedPTORequest.requestObj.is_full_last_day;
            start_time = selectedPTORequest.requestObj.start_time;
            end_time = selectedPTORequest.requestObj.end_time;
            comment = selectedPTORequest.requestObj.comment;
        }



        this.setState({requestObj: {
            ...requestObj,
            is_paid: isPaid,
            id: id,
            time_off_name: time_off_name,
            pto_type:Number(pto_type),
            status: status,
            is_full_first_day: is_full_first_day,
            is_full_last_day: is_full_last_day,
            start_time: start_time,
            end_time: end_time,
            
        }})

        

        if (this.props.agencyLocation) {
            this.getRequestUserSickLeaveInfo();
            
        }
    }

    getRequestUserSickLeaveInfo = async () => {
        this.setState({isLoading: true});
        let data = { };
        let id= this.props.selectedUser || getUser().id;
        let year=this.props.year;
        try {
          const resultSL = await SickLeaveService.getPaidSickLeaveUsers(id, year)
        this.setState({
            is_sick_leave_allowed_for_user: resultSL.data["allowed_paid_sick_leave"]
        })
                
            
        } catch(error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        this.setState({isLoading: false});
    }

    getSickLeaveSetting = async() =>{
        const resultSL = await SickLeaveService.getSickLeaveSetting(this.props.agencyLocation,this.state.year)
        this.setState({is_sick_leave_allowed:resultSL.data['is_sick_leave_allowed']})
    }

    getHolidayList = async () => {
        try {
            let locationId = getUser().agency_location;
            const year = new Date().getFullYear();
            const result = await this.props.ptoSetting(
                locationId, {}, year, "GET"
            );
            if (result) {
                const {settings} = this.props.pto;
                await this.props.getAssignedHolidayList(settings.id);
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    }

    
    
    getPTOType = async () => {
        try {
            await this.props.getPTOTypeList(this.props.agencyLocation);
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    }

    getTimeOffList = async () => {
        try {
            await this.props.getTimeOffList(this.props.selectedUser || getUser().id);
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    }
    
    handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        const {requestObj} = this.state;
        if (name === "pto_type") {
            if (Number(value)) {
                value = Number(value);
                this.setState({requestObj: {...requestObj, [name]: value}});
            }
            return;
        } 
        this.setState({requestObj: {...requestObj, [name]: value}});
    };

    handleTimeOffChange = (name, values) => {
        const {floatValue} = values;
        const {requestObj} = this.state;
        
        this.setState({requestObj: {...requestObj, [name]: floatValue}});
    }

    handleDateChangeRaw = (event) => {
		event.preventDefault();
    };
    
    handleDateChange = (date, name) => {
        this.setState({[name]: moment(date)}, () => {
            this.updateAllDayCheckBox()
        });
    }

    updateAllDayCheckBox = () => {
        const {startDate, endDate, requestObj} = this.state;
        
        if (startDate && endDate) {
            if (moment(startDate) < moment(endDate)) {}
            else if (moment(startDate) > moment(endDate)) {}
            else {
                this.setState({requestObj: {
                    ...requestObj,
                    is_full_last_day: requestObj.is_full_first_day
                }})
            }
        }
    }

    isValid = () => {
        let error = {...this.state.error};
        let isError = false;
        const {requestObj, startDate, endDate} = this.state;
        
        let curTime = moment().format("HH:mm");
        let curDate = moment().format("YYYY-MM-DD");
        let isStaff = this.props.isStaff;
        if(this.state.sick_leave_request!=="sick-leave"){
            if (Number(requestObj.pto_type)) {
                error.pto_type = "";
            } else {
                isError = true;
                error.pto_type = "The field is required.";
            }
        }
        
        if (startDate && startDate !== "Invalid date") {
            if (requestObj.is_full_first_day) {
                error.start_date = "";
            } else {
                if (requestObj.start_time) {
                    error.start_date = "";
                    let stDate = moment(startDate).format("YYYY-MM-DD");
                    if (stDate === curDate && curTime > requestObj.start_time && isStaff) {
                        isError = true;
                        error.start_date = "Please provide upcoming time.";
                    }
                    if(stDate === curDate && curTime > requestObj.start_time && !isStaff){
                        
                        requestObj.isPreviousTimeForTheSameDay = true;
                        this.setState(requestObj)
                        
                    }
                    else{
                        requestObj.isPreviousTimeForTheSameDay = false;
                        this.setState(requestObj)
                    }
                    

                    
                } else {
                    isError = true;
                    error.start_date = "Please provide time.";
                }
            }
        } else {
            isError = true;
            error.start_date = "The date field is required and needed vaild date.";
        }
        if (endDate && endDate !== "Invalid date") {
            if (requestObj.is_full_last_day) {
                error.end_date = "";
            } else {
                if (requestObj.end_time || startDate === endDate) {
                    error.end_date = "";
                    let eDate = moment(startDate).format("YYYY-MM-DD");
                    if (eDate === curDate && curTime > requestObj.end_time && isStaff) {
                        isError = true;
                        error.end_date = "Please provide upcoming time.";
                    }
                } else {
                    isError = true;
                    error.end_date = "Please provide time.";
                }
            }
        } else {
            isError = true;
            error.end_date = "The date field is required and needed vaild date.";
        }
        this.setState({error});
        return !isError;        
    }

    submitRequest = async (e) => {
        e.preventDefault();
        this.setState({isLoading: true});
        try {
            if (this.isValid()) {
                const {requestObj, startDate, endDate} = this.state;
                
                if (endDate < startDate) {
                    toast.error("Time off end date can not be less than the start date.");
                    this.setState({isLoading: false});
                    return;
                }
                let newRequestObj = {
                    ...requestObj,
                    user: this.props.selectedUser || getUser().id,
                    start_date: moment(startDate).format("YYYY-MM-DD"),
                    end_date: moment(endDate).format("YYYY-MM-DD")
                }
                let action = "POST";
                if (newRequestObj.id) {
                    action = "PUT";
                }
                if (this.state.sick_leave_request=="time-off"){
                    const result = await this.props.TimeOffRequest(newRequestObj, action);

                    if (result) {
                        toast.success("Request saved successfully.");
                        this.clearRequest();
                        this.props.refreshPTOInfos();
                        if (action === "PUT"){
                            this.props.toggleModal();
                        }
                    }
                }else if (this.state.sick_leave_request=="sick-leave" && newRequestObj.id){
                    try{
                        const resultSL = await SickLeaveService.modifySickLeaveRequest(newRequestObj.id,newRequestObj)
                        if (resultSL) {
                            this.setState({sickLeaves:resultSL.data})
                            toast.success("Sick Leave Request saved successfully.");
                            this.clearRequest();
                            this.props.refreshPTOInfos();
                        }
                    }catch(error)
                    {
                        const error_encountered= error.response.data.errors[0]['error'];
                        toast.error(""+error_encountered+"", {autoClose: 5000});
        
                    }
                }
                else{
                    try{
                        const resultSL = await SickLeaveService.createSickLeaveRequest(newRequestObj)
                        if (resultSL) {
                            this.setState({sickLeaves:resultSL.data})
                            toast.success("Sick Leave Request saved successfully.");
                            this.clearRequest();
                            this.props.refreshPTOInfos();
                        }
                    }catch(error)
                    {
                        const error_encountered= error.response.data.errors[0]['error'];
                        toast.error(""+error_encountered+"", {autoClose: 5000});
        
                    }
                        
                }
                

            }
        } catch(error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
        this.setState({isLoading: false});
    }

    openDeleteConfirmation = (e) => {
        e.preventDefault();
        let showConfirmModal = true, size="sm", hide=this.closeConfirmationModal;
        let msgTitle = "Confirmation!";
        let msgBody = <p>Are you sure, you want to cancel this request?</p>
        let buttons = [
            {
                className: "btn btn-danger",
                onClick: () => this.deleteRequest(),
                label: "Yes"
            },
            {
                className: "btn btn-default",
                onClick: this.closeConfirmationModal,
                label: "No"
            }
        ];
        this.setState({
            confirmationModalData: {
                showConfirmModal, size, hide, msgTitle, msgBody, buttons
            }
        });
        return false;
    }

    deleteRequest = async () => {
        this.setState({isLoading: true});
        if (this.state.sick_leave_request=="time-off"){
            try {
                const result = await this.props.TimeOffRequest(
                    this.state.requestObj, "DELETE"
                );
    
                if (result) {
                    toast.success("Request has been canceled successfully.");
                    this.clearRequest();
                    this.props.refreshPTOInfos();
                }
            } catch(error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
        }else{
            try{
                const resultSL = await SickLeaveService.cancelSickLeaveRequest(this.state.requestObj.id, this.state.requestObj)
                if (resultSL) {
                    this.setState({sickLeaves:resultSL.data})
                    toast.success("Sick Leave Request canceled successfully.");
                    this.clearRequest();
                }
            }catch(error)
            {
                const error_encountered= error.response.data.errors[0]['error'];
                toast.error(""+error_encountered+"", {autoClose: 5000});

            }
        }
        
        this.setState({isLoading: false});
    }

    closeConfirmationModal = () => {
        this.setState({
            confirmationModalData: {
                ...this.state.confirmationModalData, showConfirmModal: false
            }
        });
    }

    showTimeOffRequest = (request, clear=false) => {
        this.setState({
            requestObj: clear ? {...EMPTY_REQUEST} : {...request},
            startDate: clear ? null : moment(request.start),  
            endDate: clear ? null : moment(request.end),
           

            error: {}
        });
    }

    clearRequest = () => {
        this.setState({
            requestObj: {...EMPTY_REQUEST},
            startDate: null,  endDate: null,
            error: {}
        });
    }

    
    
    renderPTOType = () => {

       
        return this.props.pto.typeList.map((type, index)=>{
            return <option key={index} data-selected={type.name} value={type.id}>{type.name}</option>
        });


      //  return this.props.pto.typeList.map((type, index) => {
        //    if (this.state.requestObj.time_off_name===type.name){
             //   return;
          //  }
           //return <option key={index} value={type.id}>{type.name}</option>
    //    });
    }

    handleAlldayChange = (name) => {
        const {requestObj} = this.state;
        this.setState({requestObj : {
            ...requestObj, 
            [name]: !requestObj[name],
        }}, () => this.updateAllDayCheckBox())
    }

    renderStartDayOff = () => {
        const {requestObj, startDate} = this.state;
        
        return startDate ?
            <div className="w-70 d-flex justify-content-between align-items-center">
                {!requestObj.is_full_first_day ?
                    <TimeField className={'w-70'}
                        time={requestObj.start_time}
                        onValueChange={(time) => 
                            this.setState({requestObj : {
                                ...requestObj, start_time: time
                            }})
                        }
                    />
                    : <div></div>
                }
                <div className="form-check">
                    <label className="form-check-label position-relative">
                        <Input type="checkbox" 
                            className="form-check-input my-0" 
                            value={requestObj.is_full_first_day} 
                            checked={requestObj.is_full_first_day} 
                            onChange={() => this.handleAlldayChange('is_full_first_day')} 
                        /> &nbsp; 
                        All Day
                    </label>
                </div>
            </div>
        : null;
    }

    renderEndDayOff = () => {
        const {requestObj, startDate, endDate} = this.state;
        
        return startDate && endDate && moment(startDate) <= moment(endDate) ?
            <div className="w-70 d-flex justify-content-between align-items-center">
                {!requestObj.is_full_last_day ?
                    <TimeField className={'w-70'}
                        time={requestObj.end_time}
                        onValueChange={(time) => 
                            this.setState({requestObj : {
                                ...requestObj, end_time: time
                            }})
                        }
                    />
                    : <div></div>
                }
                {moment(startDate) < moment(endDate) ?
                    <div className="form-check">
                        <label className="form-check-label position-relative">
                            <Input type="checkbox" 
                                className="form-check-input my-0" 
                                value={requestObj.is_full_last_day} 
                                checked={requestObj.is_full_last_day} 
                                onChange={() => this.handleAlldayChange('is_full_last_day')} 
                            /> &nbsp; 
                            All Day
                        </label>
                    </div> : <div></div>
                }
            </div>
        : null;
    }

    render = () => {
        
        const {
            requestObj, isLoading, error, confirmationModalData, startDate, endDate
        } = this.state;
        const today = moment();

        
        // used as value for the first option...
        
        const {permission} = this.props;
        const {settings, staffPTOInfo} = this.props.pto;

        let availablePTO = 1000;
        
        if (staffPTOInfo.total_pto_accrued !== undefined) {
            availablePTO = staffPTOInfo.total_pto_accrued - (
                staffPTOInfo.used_pto + staffPTOInfo.scheduled_pto
            )
        }
        let isPaid = availablePTO <= 0 ? 
            false : requestObj.is_paid || settings.is_unlimited_pto;
        
        return (
            <div className="row">
                <div className="col-sm-6">
                    <div className="card section-border h-100 bg-f5">
                        <form className="card-body">
                            <div className="form-group">
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                <div className="form-check">
                                        <label className="form-check-label position-relative">
                                            <Input type="radio" 
                                                id="time-off"
                                                className="form-check-input my-0" 
                                                value="time-off"
                                                checked={this.state.sick_leave_request === "time-off"}
                                                onChange={this.Radiochangehandler}
                                                disabled={
                                                    this.state.requestObj.id
                                                   }
                                            /> &nbsp; 
                                             Time off
                                        </label>
                                    </div>
                                    {this.state.is_sick_leave_allowed_for_user && this.state.is_sick_leave_allowed? <div className="form-check">
                                        <label className="form-check-label position-relative">
                                            <Input type="radio" 
                                                id="sick-leave"
                                                className="form-check-input my-0" 
                                                value="sick-leave"
                                                checked={this.state.sick_leave_request === "sick-leave"}
                                                onChange={this.Radiochangehandler}
                                                disabled={
                                                    this.state.requestObj.id
                                                   }
                                            /> &nbsp; 
                                             Sick Leave
                                        </label>
                                    </div> :null }
                                    

                                    
                                    <div className="form-check">
                                    <label className="form-check-label position-relative">
                                            <Input type="checkbox" 
                                                className="form-check-input my-0" 
                                                value={isPaid} 
                                                checked={isPaid} 
                                                onChange={() => this.setState({
                                                    requestObj: {
                                                        ...requestObj,
                                                        is_paid: !requestObj.is_paid
                                                    }
                                                })} 
                                                disabled={
                                                    settings.is_unlimited_pto ||
                                                    availablePTO <= 0 || this.state.sick_leave_request === "sick-leave" || this.state.requestObj.id
                                                }
                                            /> &nbsp; 
                                            Paid time off
                                        </label>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                    <select name="pto_type" 
                                        className="form-control w-60 width-select"
                                        value={requestObj.pto_type}
                                        onChange={this.handleChange}
                                        autoFocus={true}
                                        disabled={
                                         this.state.sick_leave_request === "sick-leave" || this.state.requestObj.id
                                        }
                                    >
                                        {requestObj.time_off_name === null ?
                                        <option value={0}>Select Time off Type</option>  
                                        
                                        
                                    :
                                     this.renderPTOType()

                                    }

                                    {requestObj.time_off_name === null &&
                                        this.renderPTOType()
                                    }
                                       

                                        
                                    </select>
                                    
                                </div>
                                {error.pto_type ?
                                    <span className="text-danger">
                                        {error.pto_type}
                                    </span>
                                    : null
                                }
                            </div>
                            <div className="form-group">
                                <label className="mb-1">Time off start date</label>
                                <div className="d-flex">
                                    <div className="div-datepicker w-40">
                                        <DatePicker
                                            selected={startDate}
                                            onChangeRaw={this.handleDateChangeRaw}
                                            onChange={(date) => this.handleDateChange(date, "startDate")}
                                            fixedHeight dateFormat="MM/DD/YYYY"
                                            showMonthDropdown showYearDropdown
                                            dropdownMode="select" 
                                            className="form-control"
                                            minDate={this.props.isStaff?moment():null}
                                            maxDate={moment().add(1, 'year')}
                                            autoComplete="off" list="autocompleteOff"
                                        />
                                    </div>
                                    {this.renderStartDayOff()}
                                </div>
                                {error.start_date ?
                                    <span className="text-danger">
                                        {error.start_date}
                                    </span>
                                    : null
                                }
                            </div>
                            <div className="form-group">
                                <label className="mb-1">Time off end date</label>
                                <div className="d-flex">
                                    <div className="div-datepicker w-40">
                                        <DatePicker
                                            selected={endDate}
                                            onChangeRaw={this.handleDateChangeRaw}
                                            onChange={(date) => this.handleDateChange(date, "endDate")}
                                            fixedHeight dateFormat="MM/DD/YYYY"
                                            showMonthDropdown showYearDropdown
                                            dropdownMode="select" 
                                            className="form-control"
                                            minDate={startDate ? moment(startDate) : moment()}
                                            maxDate={moment().add(1, 'year')}
                                            autoComplete="off" list="autocompleteOff"
                                        />
                                    </div>
                                    {this.renderEndDayOff()}
                                </div>
                                {error.end_date ?
                                    <span className="text-danger">
                                        {error.end_date}
                                    </span>
                                    : null
                                }
                            </div>
                            <div className="form-group">
                                <Input type="textarea" name="description" rows="2" 
                                    value={requestObj.description} 
                                    onChange={this.handleChange}
                                    maxLength={500}
                                    placeholder="Description (optional)"
                                />
                                {error.description ?
                                    <span className="text-danger">
                                        {error.description}
                                    </span>
                                    : null
                                }
                            </div>
                            {requestObj.id && this.props.isStaff && 
                                <div className="form-group">
                                    <label className="mb-1">Admin Comment</label>
                                    <Input type="textarea" rows="2" 
                                        value={requestObj.comment} 
                                        disabled={true}
                                    />
                                    <p className="mt-2">
                                        <label className="mb-0">
                                            Current Status: {
                                                PTO_REQUEST_STATUS[requestObj.status]
                                            }
                                        </label>
                                    </p>
                                </div>
                            }
                            <hr/>
                            <div className="form-group">
                                {!requestObj.id && permission.can_add ? 
                                    <button type="submit" className="btn btn-success"
                                        onClick={this.submitRequest}
                                        disabled={isLoading}
                                    >
                                        Submit Request
                                    </button>
                                : (moment(requestObj.end_date) >= today || 
                                        requestObj.status === WAITING_FOR_APPROVAL
                                         || requestObj.status === APPROVED
                                ) && 
                                    <React.Fragment>
                                        {permission.can_edit &&
                                            <button type="submit" className="btn btn-success"
                                                onClick={this.submitRequest}
                                                disabled={isLoading}
                                            >
                                                Modify Request
                                            </button>
                                        }
                                        <i className="px-2"></i>
                                        {requestObj.status !== CANCELED && permission.can_delete &&
                                            <button type="button" className="btn btn-danger"
                                                onClick={this.openDeleteConfirmation}
                                                disabled={isLoading}
                                            >
                                                Cancel Request
                                            </button>
                                        }
                                    </React.Fragment>
                                }
                                <i className="px-2"></i>
                                <button type="button" className="btn btn-dark"
                                    onClick={this.clearRequest}
                                    disabled={isLoading}
                                >Clear Form</button>
                                <i className="px-2"></i>
                                {isLoading && 
                                    <p className="loading-gif">
                                        <img src={loadingGIF} alt="Loading..." 
                                            width="32" height="32"
                                        />
                                    </p>
                                }
                            </div>
                        </form>
                        {confirmationModalData.showConfirmModal &&
                            <ConfirmModal {...confirmationModalData} />
                        }
                    </div>
                </div>
                <div className="col-sm-6 pl-sm-0">
                    <div className="card section-border h-100 bg-f5">
                        <div className="card-body">
                            <StaffCalendar {...this.props} height={"380px"}
                                showTimeOffRequest={this.showTimeOffRequest}
                            />
                        </div>
                    </div>
                </div>
            </div> 
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/pto/Request.js